(() => {
  const root = document.querySelector('[data-community-v2]');
  if (!root) return;

  const cards = [...root.querySelectorAll('[data-dog-card]')];
  const search = root.querySelector('[data-community-search]');
  const product = root.querySelector('[data-community-product]');

  const applyFilters = () => {
    const term = (search?.value || '').trim().toLowerCase();
    const productValue = (product?.value || '').trim().toLowerCase();

    cards.forEach((card) => {
      const haystack = `${card.dataset.name || ''} ${card.dataset.breed || ''}`;
      const productText = card.dataset.product || '';
      const matchesText = !term || haystack.includes(term);
      const matchesProduct = !productValue || productText.includes(productValue);
      card.hidden = !(matchesText && matchesProduct);
    });
  };

  search?.addEventListener('input', applyFilters);
  product?.addEventListener('change', applyFilters);
})();
